<template>
  <div>
    <v-row id="router" class="ma-0 pa-0" :style="viewStyle">
      <div id="listTable">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th @click="sort('examNo')" class="text-center">場次代碼<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('examDate')">認證日期<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('company')">認證考場<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class1')">認證項目<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class2')">認證模組<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class3')">認證廠商<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('payGroup')">繳費狀態<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('applyStatus')">場次狀態<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('numOfApplicants')">已報名人數<v-icon small>icon-form_sort_off</v-icon></th>
                <!-- TBD -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data,index) in datasets" :key="index">
                <td class="pt-2 pb-1 text-center" style="min-width: 130px">
                  <v-btn outlined style="height:28px; background:#215DA7; color:#FFF" @click="redirectPath('/project', data.id)"><span style="font-size:14px">詳細資訊</span></v-btn>
                  <h4>{{data.examNo}}</h4>
                </td>
                <td style="min-width: 110px"><h4>{{data.examDate}}</h4><h4>{{data.examTime}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.company}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.class1}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.class2}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.class3}}</h4></td>
                <td style="min-width: 110px">
                  <h4>{{(data.payGroup=='1') ? '團繳' : (data.payGroup=='2') ? '個人' : ''}}({{data.examFee}})</h4>
                  <!-- <h4>前往繳費</h4> -->
                </td>
                <td style="min-width: 110px">
                  <h4 :style = "[{'color' : (data.applyStatus==1) ? '#444' : (data.applyStatus==2) ? '#215DA7' : (data.applyStatus==3) ? '#444' : (data.applyStatus==4) ? '#F00' : '#F00'}]">
                    {{$Global.getTypevDescription(applyStatusList,data.applyStatus)}}</h4>
                </td>
                <td style="min-width: 120px">
                  <h4>{{data.numOfApplicants}}人</h4>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    
      <v-row class="px-5 py-0">
        <v-col class="col-0 col-sm-0 col-md-2 col-lg-7 pagination-max pl-5 mt-3 text-right pr-8">共 {{pagination.totalCount}} 筆</v-col>
        <v-col class="col-12 col-sm-8 col-md-6 col-lg-3 pr-0">
          <v-pagination color="#81C0E2" v-model="pagination.page" :length="pagination.totalPage"
          :total-visible="5"></v-pagination>
        </v-col>
        <v-col class="col-12 col-sm-4 col-md-4 col-lg-2">
          <v-row class="row">
            <v-col class="col-5 col-sm-4 pt-3 text-right">前往</v-col>
            <v-col class="col-2 col-sm-4 pa-0">
            <v-text-field outlined dense v-model="destPage" @keyup.enter="setDestPage()"></v-text-field>
            </v-col>
            <v-col class="col-5 col-sm-4 pt-3 text-left">頁</v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
  </div>
</template>

<script>


export default {
  name: 'ProjectList',
  components: {},
  mounted(){
    this.$Global.getApplyStatusList().then(res=>{ this.applyStatusList = res })
    this.getDataset()
  },
  data:() => ({
    select:'',
    keyword:'',
    datasets: [],
    pagination:{page:1,totalPage:0,totalCount:0},
    orderBy:'examDate',
    direction:'desc',
    destPage:'',
    showRange:false,
    viewStyle:{},

    memberSearchStatus: false,
    startDate:'',
    endDate:'',
    menuS:'',
    menuE:'',

    applyStatusList: [],
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    "pagination.page":function(){
      this.getDataset()
    }
  },
  computed: {},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-64 + 'px'}
    },
    redirectPath(path, id){
      this.$router.push({path: path, query: {id: this.$Global.encrypt(JSON.stringify(id))}})
    },
    setDestPage(){
      this.pagination.page = parseInt(this.destPage)
    },
    sort(field){
      this.orderBy = field
      this.direction = (this.direction == 'desc') ? 'asc' : 'desc'
      this.getDataset()
    },
    search(){
      (this.pagination.page == 1) ? this.getDataset() : this.pagination.page = 1
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExamListByIdCard',
        params: {
          'page': self.pagination.page,
          'limit': 10,
          'order': self.orderBy,
          'direction': self.direction,
          'teacherIdCard': sessionStorage.getItem('cerpsMemberIdCard'),
        },
      }
      this.$http(request).then(function(response) {
        if(response.data.msg == '成功!'){
          self.datasets = response.data.data.data
          self.pagination.totalCount = response.data.data.total
          self.pagination.totalPage = response.data.data.page
        }
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為pjl-7956')
      })
    },
  }
}
</script>

<style>
  @media (max-width: 959px) {
    .pagination-max {
      display: none !important;
    }
  }
</style>